let count = 0;

export function noteLaunchDarklyIdentify() {
  count += 1;
}

/** Identify requests actually sent this page load; calls deduped onto an in-flight one do not count. */
export function launchDarklyIdentifyCount() {
  return count;
}

export type LaunchDarklyIdentifySkip =
  /** A caller asked to identify before the SDK had a client; a later one can still recover it. */
  | "client-not-ready"
  /** The boot gate rendered without one, so the session is on anonymous flags. */
  | "gave-up-waiting"
  /** The SDK had a client but never took the identify, same result. */
  | "identify-failed";

let skip: LaunchDarklyIdentifySkip | null = null;

export function noteLaunchDarklyIdentifySkipped(
  reason: LaunchDarklyIdentifySkip,
) {
  // Renders carry on after the session is already anonymous, and their skips
  // must not downgrade the reason it got that way.
  if (skip !== null && skip !== "client-not-ready") return;
  skip = reason;
}

export function launchDarklyIdentifySkipped() {
  return skip;
}
